import {useHistory } from "react-router-dom";
import Header from './Header.js';
import Footer from './Footer.js';
import CheckStatus2 from "./CheckStatus2.js";

function Home() {
  const history = useHistory();
localStorage.clear()

  function handleClick() {
    history.push("/validate-mobile");
  }

  function handleClick2() {
    window.location ="https://readplaywin.com"
  
  }

  var d = new Date();
     var n = d.getSeconds();

  // if(n>30){
  return (
      <>
<Header/>

{/* <h2 style={{marginTop: 110, textAlign: 'center', color: 'green'}}>We are reviewing your Applications</h2>
<h4 style={{ textAlign: 'center', color: 'red'}}><u>IMPORTANT NOTICE</u></h4>
<p style={{textAlign:'justify', color: 'red', fontSize: 14, marginTop: 10, marginLeft: 40, marginRight: 40}}> We currently have an unprecedented Applications number of over 6 Million. This is more than the Nigerian Empowerers' NGO has ever empowered. Payments will therefore be splitted in batches. More information on payments schedules will be highlighted soon. </p>  */}

 {/* <marquee style={{color: 'green', marginTop: 12}} scrolldelay="300"><h5>As on the 3rd day of March 2021, Over 6 Million Nigerian Youths have applied for the Nigerian Youths Empowerment 2021. These youths are hereby informed that payments will begin by March.  </h5></marquee>  */}
     <div class="jumbotron jumbotron-fluid" style={{marginTop: 60}}>
  <div class="container">
    <h3>Let's Empower You !</h3>
    <p style={{textAlign:'justify', fontSize: 15, marginTop: 17}}>The future of Nigeria lies in the hands of the youths. Several Foreign and Local Philanthropists have seen this as well and have decided to empower these youths. This goal is being set to reality through the Nigeria Youth Empowerers' NGO.</p>
    <hr/>
<button onClick={handleClick} type="button" class="btn btn-success" style={{float: 'left'}}>Apply Now</button>
{/* <button onClick={handleClick2} type="button" class="btn btn-primary" style={{float: 'left', marginLeft: 10}}>Win Money</button> */}

{/* <marquee style={{color: 'green', marginTop: 12}} scrolldelay="300"><h5>As on the 6th day of March 2021, Over 5.5 Million Nigerian Youths have applied for the Nigerian Youths Empowerment 2021. These youths are hereby informed that payments will begin by March.  </h5></marquee> */}
{/* <p style={{color: 'red', marginBottom: 0 }}>NOTE: All repeated applications are nullified. </p>
<p style={{color: 'red', fontWeight: 'bold', marginBottom: 0  }}>Closing Date:  26th March 2021</p> */}
<br/>
<br/>

<hr/>
<CheckStatus2/>
  </div>
</div>  


<Footer/>

</>
  );
// }
//   else{
//     window.location ="https://empowernigerianyouths2021.web.app/"
   
//     }
 }

export default Home;
